import {
  Stack,
  Paper,
  Typography,
  FormControlLabel,
  useTheme,
  useMediaQuery,
  TextField,
  Checkbox,
  Alert,
  Box,
} from "@mui/material";
import React, { useEffect } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import VmCarousel from "pages/Login/VmCarousel";
import Logo from "layouts/Drawer/Logo";
import { LoadingButton } from "@mui/lab";
import { useDispatch, useSelector } from "react-redux";
import { getToken } from "store/reducers/auth";
import { useLocation, useNavigate } from "react-router-dom";

const validation = yup.object({
  username: yup.string("Enter your username").required("Username required"),
  password: yup.string("Enter your username").required("Password required"),
});

function Login() {
  const theme = useTheme();
  const formik = useFormik({
    initialValues: { username: "", password: "", remember: false },
    validationSchema: validation,
    onSubmit: (data) => {
      dispatch(getToken(data));
    },
  });

  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  useEffect(() => {
    if (auth.isLoggedIn) {
      navigate(from, { replace: true });
    }
  }, [auth.isLoggedIn, navigate, from]);

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      sx={{
        width: "100%",
        height: "100vh",
        bgcolor: "background.default",
      }}
    >
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        component={Paper}
        borderRadius={0}
        elevation={3}
        sx={{
          minWidth: "280px",
          width: { xs: "90%", sm: "60%", md: "80%", lg: "35%" },
          height: { lg: "90vh" },
        }}
      >
        <Stack
          flexDirection="column"
          flexGrow={1}
          sx={{ width: "100%", bgcolor: "background.paper", maxHeight: "90vh" }}
          justifyContent="center"
          alignItems="start"
          padding={{ xs: 4, sm: 4, md: 6, lg: 6 }}
        >
          <Box sx={{ alignSelf: "center" ,mb:5}}>
            <Logo width={380}  />
          </Box>
          <Typography variant="h3" color="text.secondary" mt={5}>
            Login
          </Typography>
          <Typography variant="subtitle2" color="text.secondary">
            Please enter your details to get sign into your account
          </Typography>
          <form onSubmit={formik.handleSubmit}>
            <TextField
              label="Username"
              variant="outlined"
              name="username"
              fullWidth
              sx={{ mt: 3 }}
              value={formik.values.username}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.username)}
              helperText={formik.errors.username}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              label="Password"
              variant="outlined"
              fullWidth
              name="password"
              type="password"
              sx={{ mt: 3 }}
              value={formik.values.password}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.password)}
              helperText={formik.errors.password}
              InputLabelProps={{ shrink: true }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="remember"
                  checked={formik.values.remember}
                  value={formik.values.remember}
                  color="primary"
                />
              }
              label="Remember login"
              sx={{ mt: 3 }}
              onChange={formik.handleChange}
              name="remember"
            />
            {auth.errorMessage && (
              <Alert severity="error">{auth.errorMessage}</Alert>
            )}
            {auth.isLoggedIn && <Alert severity="success">Success</Alert>}
            <LoadingButton
              loading={auth.loading}
              variant="contained"
              fullWidth
              sx={{ mt: 2 }}
              type="submit"
            >
              Login
            </LoadingButton>
          </form>

          <Typography align="center" sx={{ width: "100%", mt: 2 }}>
            © 2024 VENDCRAFTZ PVT LTD
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
}

export default Login;
